/*
 * Napp fitment selector (storefront). Needs napp-fitment-core.js (window.NappFitment).
 * - A "Your Miata" bar at the top of every page; the customer's car is kept in this browser only.
 * - The selector: year, then the transmissions that year was sold with, then (1991 only, optional) the crank check:
 *   VIN box + "Confirmed Long Nose Crank" / "Confirmed Short Nose Crank" / "I don't care".
 * - Collection pages: with ?fits=1 only the parts that don't rule themselves out for the car are listed (unapproved
 *   and "check your crank" parts stay); without it, a quiet "Show only parts that fit" link. My Garage's
 *   "Shop this Chassis" (agent/customer-garage) writes localStorage "napp-miata" and opens ?fits=1: keep KEY's shape.
 * - "Shop without a car" in the bar (ruling 624) clears the car and remembers that choice (NO_CAR) so product pages
 *   show no fit message at all until a car is picked again (Save my Miata, or Shop this Chassis in My Garage).
 *   [coupling] My Garage writes KEY only, so a car in KEY always outranks the marker; garage never needs NO_CAR.
 * - Product pages: one message from the approved fitment (product metafield napp_fitment.vehicles) and, when the
 *   car settles an option, that option is picked for the customer.
 * Copy approved by Stefan before go-live (fitment-selector plan, step 3).
 */
(function () {
  "use strict";
  var F = window.NappFitment;
  if (!F) return;
  var KEY = "napp-miata";
  var NO_CAR = "napp-miata-none";  // "1" after "Shop without a car"; cleared when a car is saved here
  var CONTACT = "/pages/contact";

  function load() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || "null"); return v && F.generation(v.year) ? v : null; }
    catch (e) { return null; }
  }
  function save(v, withoutCar) {
    noCar = !v && !!withoutCar;
    try {
      noCar ? localStorage.setItem(NO_CAR, "1") : localStorage.removeItem(NO_CAR);  // first: a failed KEY write can't strand it
      v ? localStorage.setItem(KEY, JSON.stringify(v)) : localStorage.removeItem(KEY);
    } catch (e) { /* private mode */ }
  }
  var car = load();
  var noCar = !car && (function () { try { return localStorage.getItem(NO_CAR) === "1"; } catch (e) { return false; } })();

  function h(tag, attrs) {
    var n = document.createElement(tag);
    for (var k in attrs || {}) {
      if (k === "text") n.textContent = attrs[k];
      else if (k === "on") for (var ev in attrs.on) n.addEventListener(ev, attrs.on[ev]);
      else n.setAttribute(k, attrs[k]);
    }
    (function add(kids) {
      kids.forEach(function (k) { if (Array.isArray(k)) add(k); else if (k != null) n.append(k); });
    })(Array.prototype.slice.call(arguments, 2));
    return n;
  }
  // Simple roadster profile, drawn in the text colour (decorative).
  var CAR_SVG = '<svg viewBox="0 0 32 16" width="28" height="14" aria-hidden="true" focusable="false"><path fill="currentColor" d="M3 11.5c0-1.6.9-2.6 2.6-3l4.6-1.1 3.5-2.6c.6-.4 1.3-.6 2-.6h4.7c.8 0 1.5.3 2 .9l2 2.2 3.6.7c1.4.3 2.4 1.5 2.4 2.9v.6c0 .6-.4 1-1 1h-1.6a3.2 3.2 0 0 0-6.2 0h-8.8a3.2 3.2 0 0 0-6.2 0H4c-.6 0-1-.4-1-1zm12.3-5.3-2.4 1.9h6.6l-.1-2.4h-2.6c-.6 0-1.1.2-1.5.5zm5.5-.5.1 2.4h3.9l-1.7-1.9c-.3-.3-.6-.5-1-.5zM9.6 12.2a2.2 2.2 0 1 1 0 .1zm15 0a2.2 2.2 0 1 1 0 .1z"/></svg>';
  function icon() { var s = document.createElement("span"); s.className = "napp-fit-icon"; s.innerHTML = CAR_SVG; return s; }
  function carName(v) { return v.year + " Miata"; }
  function carDetail(v) {
    var s = F.TRANS_LABEL[v.trans] || "";
    if (+v.year === 1991 && (v.crank === "short" || v.crank === "long")) s += ", " + v.crank + " nose crank";
    return s;
  }

  /* ---------- selector dialog ---------- */
  var dialog, draft;
  function buildDialog() {
    dialog = h("dialog", { class: "napp-fit-dialog", "aria-labelledby": "napp-fit-title" });
    document.body.append(dialog);
    dialog.addEventListener("click", function (e) { if (e.target === dialog) dialog.close(); });
  }
  function openSelector(focusCrank) {
    if (!dialog) buildDialog();
    draft = car ? { year: car.year, trans: car.trans, crank: car.crank || null, vin: "" } : { year: "", trans: "", crank: null, vin: "" };
    renderDialog(focusCrank);
    dialog.showModal();
  }
  function renderDialog(focusCrank) {
    var years = h("select", { id: "napp-fit-year", class: "napp-fit-select" }, h("option", { value: "", text: "Year" }));
    F.modelYears().forEach(function (y) {
      var o = h("option", { value: String(y), text: String(y) });
      if (+draft.year === y) o.selected = true;
      years.append(o);
    });
    years.addEventListener("change", function () {
      draft.year = years.value ? +years.value : "";
      if (F.transFor(draft.year).indexOf(draft.trans) < 0) draft.trans = "";
      if (!F.needsCrankQuestion(draft.year)) draft.crank = null;
      renderDialog();
      var t = dialog.querySelector(".napp-fit-choice"); if (t) t.focus();
    });

    var trans = null;
    if (draft.year) {
      trans = h("div", { class: "napp-fit-choices", role: "group", "aria-label": "Transmission" });
      F.transFor(draft.year).forEach(function (t) {
        trans.append(h("button", { type: "button", class: "napp-fit-choice", "aria-pressed": String(draft.trans === t),
          text: F.TRANS_LABEL[t], on: { click: function () { draft.trans = t; renderDialog(); } } }));
      });
    }

    var crank = F.needsCrankQuestion(draft.year) ? crankStep() : null;
    var ready = draft.year && draft.trans;
    dialog.replaceChildren(
      h("form", { method: "dialog", class: "napp-fit-form", on: { submit: function (e) {
          e.preventDefault();
          if (!ready) return;
          car = { year: draft.year, trans: draft.trans, crank: F.needsCrankQuestion(draft.year) ? draft.crank : null };
          save(car); dialog.close(); refresh(true);
        } } },
        h("h2", { id: "napp-fit-title", class: "napp-fit-title", text: "Select your Miata" }),
        h("p", { class: "napp-fit-hint", text: "We'll tell you on every part whether it fits. Saved on this device only." }),
        h("label", { class: "napp-fit-label", for: "napp-fit-year", text: "Model year" }), years,
        trans ? h("p", { class: "napp-fit-label", text: "Transmission" }) : null, trans,
        crank,
        h("div", { class: "napp-fit-actions" },
          h("button", { type: "submit", class: "button button--primary napp-fit-save", text: "Save my Miata" }),
          car ? h("button", { type: "button", class: "napp-fit-link", text: "Forget my car",
            on: { click: function () { car = null; save(null); dialog.close(); refresh(true); } } }) : null,
          h("button", { type: "button", class: "napp-fit-link", text: "Cancel", on: { click: function () { dialog.close(); } } }))));
    dialog.querySelector(".napp-fit-save").disabled = !ready;
    if (focusCrank) { var v = dialog.querySelector("#napp-fit-vin"); if (v) v.focus(); }
  }

  function crankStep() {
    var result = h("p", { class: "napp-fit-vin-result", role: "status" });
    var vin = h("input", { id: "napp-fit-vin", class: "napp-fit-input", type: "text", inputmode: "text",
      autocomplete: "off", autocapitalize: "characters", spellcheck: "false", maxlength: "20",
      placeholder: "17-character VIN" });
    vin.value = draft.vin;
    function check() {
      draft.vin = vin.value;
      var r = F.crankFromVin(vin.value);
      result.textContent = r.message;
      result.className = "napp-fit-vin-result " + (r.ok ? "is-ok" : "is-bad");
      if (r.ok) { draft.crank = r.crank; paint(); }
    }
    vin.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); check(); } });
    var buttons = [["long", "Confirmed Long Nose Crank"], ["short", "Confirmed Short Nose Crank"], ["any", "I don't care"]]
      .map(function (b) {
        return h("button", { type: "button", class: "napp-fit-choice", "data-crank": b[0], text: b[1],
          on: { click: function () { draft.crank = b[0]; paint(); } } });
      });
    function paint() { buttons.forEach(function (b) { b.setAttribute("aria-pressed", String(b.dataset.crank === draft.crank)); }); }
    paint();
    return h("div", { class: "napp-fit-crank" },
      h("p", { class: "napp-fit-label", text: "1991: short or long nose crank? (optional)" }),
      h("p", { class: "napp-fit-hint", text: "1991 Miatas changed from a short nose to a long nose crank part way through the year. Some parts fit only one. Enter your VIN to check, or pick one below." }),
      h("label", { class: "napp-fit-visually-hidden", for: "napp-fit-vin", text: "VIN" }),
      h("div", { class: "napp-fit-vin-row" }, vin,
        h("button", { type: "button", class: "button button--secondary napp-fit-vin-check", text: "Check VIN", on: { click: check } })),
      result,
      h("div", { class: "napp-fit-choices", role: "group", "aria-label": "Crank" }, buttons));
  }

  /* ---------- "Your Miata" bar ---------- */
  var bar;
  function renderBar() {
    var main = document.getElementById("MainContent");
    if (!main) return;
    if (!bar) {
      bar = h("div", { class: "napp-fit-bar" }, h("div", { class: "napp-fit-bar-inner page-width" }));
      main.prepend(bar);
    }
    var inner = bar.firstChild;
    if (car) {
      var g = F.generation(car.year);
      bar.classList.add("has-car");
      inner.replaceChildren(icon(), h("span", { class: "napp-fit-bar-car" }, "Shopping for your ",
          h("strong", { text: carName(car) }), h("span", { class: "napp-fit-bar-detail", text: " · " + carDetail(car) })),
        h("span", { class: "napp-fit-bar-actions" },
          h("button", { type: "button", class: "napp-fit-pill", text: "Change", on: { click: function () { openSelector(); } } }),
          h("button", { type: "button", class: "napp-fit-pill", text: "Shop without a car", on: { click: shopWithoutCar } }),
          h("a", { class: "napp-fit-link", href: fitsUrl(g), text: "Shop " + g.code + " parts that fit" })));
    } else {
      bar.classList.remove("has-car");
      inner.replaceChildren(icon(), h("span", { class: "napp-fit-bar-car" }, h("strong", { text: "Select your Miata" }),
          " to see which parts fit"),
        h("span", { class: "napp-fit-bar-actions" },
          h("button", { type: "button", class: "napp-fit-pill is-solid", text: "Select your Miata", on: { click: function () { openSelector(); } } })));
    }
  }

  function shopWithoutCar() {
    car = null; save(null, true); refresh(true);
    var next = bar && bar.querySelector(".napp-fit-pill"); if (next) next.focus();  // the pressed button is gone
  }

  /* ---------- product page ---------- */
  var dataEl = document.getElementById("napp-fitment-data");
  var data = dataEl ? JSON.parse(dataEl.textContent) : null;
  var badge, firstLoad = true;

  function anchor() {
    return document.querySelector("variant-radios, variant-selects") ||
      document.querySelector("product-form, .product-form") || document.querySelector(".product__info-container .price");
  }

  function renderBadge(fromChange) {
    if (!data || (!data.rule && !data.part)) return;
    if (!car && noCar) { if (badge) { badge.remove(); badge = null; } return; }
    var where = anchor();
    if (!where) return;
    if (!badge) { badge = h("div", { class: "napp-fit-badge", role: "status" }); where.before(badge); }
    var change = h("button", { type: "button", class: "napp-fit-link", text: "Change car", on: { click: function () { openSelector(); } } });
    if (!car) {
      badge.className = "napp-fit-badge is-none";
      badge.replaceChildren(icon(), h("span", { class: "napp-fit-badge-text" }, h("strong", { text: "Will this fit your Miata?" }),
          " Pick your year and transmission to check."),
        h("button", { type: "button", class: "napp-fit-pill is-solid", text: "Select your Miata", on: { click: function () { openSelector(); } } }));
      return;
    }
    var v = F.verdict(data.rule, car);
    badge.className = "napp-fit-badge is-" + v.state;
    var msg;
    if (v.state === "fits") msg = [h("strong", { text: "Fits your " + carName(car) }), " (" + carDetail(car) + ")"];
    else if (v.state === "choose") {
      msg = [h("strong", { text: "Fits your " + carName(car) }), " with " + describe(v.choose) + "."];
      if (pick(v.choose, fromChange)) msg.push(" Selected for you below.");
    } else if (v.state === "nofit") {
      var g = F.generation(car.year);
      msg = [h("strong", { text: "Doesn't fit your " + carName(car) }), " (" + carDetail(car) + "). ",
        h("a", { class: "napp-fit-link", href: fitsUrl(g), text: "Shop parts that fit your " + carName(car) })];
    } else if (v.state === "crank") {
      msg = [h("strong", { text: "Check your crank" }),
        ": 1991 Miatas changed from a short nose to a long nose crank part way through the year, and this part depends on it. ",
        h("button", { type: "button", class: "napp-fit-link", text: "Check your VIN", on: { click: function () { openSelector(true); } } })];
    } else {
      msg = [h("strong", { text: "Not sure this fits your " + carName(car) + "?" }), " ",
        h("a", { class: "napp-fit-link", href: CONTACT, text: "Ask us" })];
    }
    badge.replaceChildren(icon(), h("span", { class: "napp-fit-badge-text" }, msg), change);
  }

  function describe(choose) {
    return Object.keys(choose).map(function (k) { return k + ": " + choose[k].join(" or "); }).join(", ");
  }

  // Pick the option values the car settles (one value per option). Not on first load when the link names a variant.
  function pick(choose, fromChange) {
    if (firstLoad && !fromChange && /[?&]variant=/.test(location.search)) return false;
    var picker = document.querySelector("variant-radios, variant-selects");
    if (!picker) return false;
    var picked = false;
    Object.keys(choose).forEach(function (name) {
      if (choose[name].length !== 1) return;
      var value = choose[name][0];
      var sets = picker.querySelectorAll("fieldset");
      for (var i = 0; i < sets.length; i++) {
        var legend = sets[i].querySelector("legend");
        if (!legend || legend.textContent.trim() !== name) continue;
        var radio = Array.prototype.find.call(sets[i].querySelectorAll('input[type="radio"]'), function (r) { return r.value === value; });
        if (radio) { picked = true; if (!radio.checked) { radio.checked = true; radio.dispatchEvent(new Event("change", { bubbles: true })); } }
      }
      picker.querySelectorAll("select").forEach(function (sel) {
        var label = picker.querySelector('label[for="' + sel.id + '"]');
        if (!label || label.textContent.trim() !== name) return;
        if (Array.prototype.some.call(sel.options, function (o) { return o.value === value; })) {
          picked = true;
          if (sel.value !== value) { sel.value = value; sel.dispatchEvent(new Event("change", { bubbles: true })); }
        }
      });
    });
    return picked;
  }

  function fitsUrl(g) { return "/collections/" + g.code.toLowerCase() + "-miata?fits=1"; }

  /* ---------- collection pages ---------- */
  var filterLine, original;
  function withParams(edit) {
    var p = new URLSearchParams(location.search);
    edit(p);
    var q = p.toString();
    return location.pathname + (q ? "?" + q : "");
  }
  function cardHandle(li) {
    var a = li.querySelector('a[href*="/products/"]');
    var m = a && a.getAttribute("href").match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function unhide(node) {  // cards fetched from other pages miss the theme's reveal-on-scroll trigger
    [node].concat(Array.prototype.slice.call(node.querySelectorAll("[class*='scroll-trigger']"))).forEach(function (n) {
      n.className = n.className.split(" ").filter(function (c) { return c.indexOf("scroll-trigger") !== 0 && c.indexOf("animate--") !== 0; }).join(" ");
    });
    return node;
  }
  async function renderCollection() {
    var grid = document.getElementById("product-grid");
    if (!grid || !/^\/collections\/[^/]+\/?$/.test(location.pathname)) return;
    var container = document.getElementById("ProductGridContainer") || grid.parentElement;
    if (!filterLine) { filterLine = h("div", { class: "napp-fit-filter page-width", role: "status" }); container.before(filterLine); }
    var on = new URLSearchParams(location.search).get("fits") === "1";
    if (!car) {
      filterLine.replaceChildren(icon(), h("span", { text: "Select your Miata to see only the parts that fit it." }),
        h("button", { type: "button", class: "napp-fit-pill", text: "Select your Miata", on: { click: function () { openSelector(); } } }));
      if (original) location.reload();
      return;
    }
    var showAll = h("a", { class: "napp-fit-link", href: withParams(function (p) { p.delete("fits"); p.delete("page"); }), text: "Show all parts" });
    if (!on) {
      filterLine.replaceChildren(icon(), h("a", { class: "napp-fit-link", href: withParams(function (p) { p.set("fits", "1"); p.delete("page"); }),
        text: "Show only parts that fit your " + carName(car) }));
      return;
    }
    filterLine.replaceChildren(icon(), h("span", { text: "Finding parts that fit your " + carName(car) + "…" }));
    try {
      var path = location.pathname.replace(/\/$/, "");
      var rules = (await (await fetch(path + "?view=napp-fits")).json()).products || {};
      if (!original) original = Array.prototype.slice.call(grid.children);
      var cards = [], seen = {}, section = grid.dataset.id;
      for (var page = 1; page <= 30; page++) {
        var url = withParams(function (p) { p.delete("fits"); p.set("page", page); p.set("section_id", section); });
        var doc = new DOMParser().parseFromString(await (await fetch(url)).text(), "text/html");
        var lis = Array.prototype.slice.call(doc.querySelectorAll("#product-grid > li"));
        var fresh = lis.filter(function (li) { var k = cardHandle(li); return k && !seen[k] && (seen[k] = true); });
        if (!fresh.length) break;  // past the last page Shopify repeats or returns nothing
        cards = cards.concat(fresh);
      }
      var keep = cards.filter(function (li) {
        var k = cardHandle(li);
        return !(k in rules) || F.verdict(rules[k], car).state !== "nofit";  // unknown / unapproved / crank stay
      });
      grid.replaceChildren.apply(grid, keep.map(function (li) { return unhide(document.importNode(li, true)); }));
      document.querySelectorAll(".pagination-wrapper, .pagination").forEach(function (p) { p.hidden = true; });
      document.querySelectorAll("#ProductCount, #ProductCountDesktop, .mobile-facets__count").forEach(function (n) {
        n.textContent = keep.length + " of " + cards.length + " products";
      });
      filterLine.replaceChildren(icon(), h("span", {}, h("strong", { text: keep.length + (keep.length === 1 ? " part fits" : " parts fit") }),
        " your " + carName(car) + " (" + carDetail(car) + ")."), showAll);
      if (!keep.length) filterLine.replaceChildren(icon(), h("span", { text: "Nothing in this collection fits your " + carName(car) + " yet." }), showAll);
    } catch (e) {
      filterLine.replaceChildren(icon(), h("span", { text: "Couldn't filter this page right now." }), showAll);
    }
  }

  function refresh(fromChange) {
    renderBar(); renderBadge(fromChange); firstLoad = false;
    if (fromChange && filterLine && new URLSearchParams(location.search).get("fits") === "1") location.reload();
    else renderCollection();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { refresh(false); });
  else refresh(false);
})();
